module.exports = function() {
  return new Worker("/" + "coffee-transpiler.3cdc6b26.worker.js");
};